import { useState } from 'react'

import ScheduleOutlinedIcon from '@ant-design/icons/ScheduleOutlined'

import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'

import useIndicator, { Indicator } from '@shared/hooks/src/useIndicator'
import { useMe } from '@shared/providers/src/MeProvider'
import { UserRole } from '@shared/utils'

import ScheduleDrawer from '@pages/Schedule'

export default function Schedule({ size }) {
  const [open, setOpen] = useState(false)
  const me = useMe()

  const { data: labsNeedReview } = useIndicator(Indicator.NeedReviewLabs, undefined, {
    select: (data) => data.show_icon,
    enabled: me.role === UserRole.Provider,
  })

  const { data: assessmentsNeedReview } = useIndicator(Indicator.PendingAssessments, undefined, {
    select: (data) => data.show_icon,
    enabled: me.role === UserRole.Provider,
  })

  return (
    <>
      <IconButton
        id="schedule-button"
        color="secondary"
        size={size}
        onClick={() => setOpen(true)}
        aria-label="Schedule toggler"
        data-testid="header-schedule"
      >
        <Badge
          color="info"
          variant="dot"
          invisible={!labsNeedReview && !assessmentsNeedReview}
          data-testid="header-schedule-badge"
          data-test-labs={labsNeedReview}
          data-test-assessments={assessmentsNeedReview}
        >
          <ScheduleOutlinedIcon style={{ fontSize: 20 }} />
        </Badge>
      </IconButton>
      <ScheduleDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
